import classNames from 'classnames'
import useSearchParams from '~/hooks/useSearchParam'

interface Props {
  activeIndex: number
  items: Array<{
    name: string
    id: string
    count?: number
    child?: any
    isNew?: boolean
  }>
  onChange: (index: number) => void
  className?: string
  hiddenUnderline?: boolean
  showCount?: boolean
}

export default function MyTabsIndex({
  items,
  activeIndex,
  onChange,
  className,
  hiddenUnderline,
  showCount = false,
}: Props) {
  const { artistid, themeid, l_1 } = useSearchParams()

  return (
    <div className={classNames('flex items-center font-semibold', className)}>
      {items.map((item, index) => {
        let count = Number(item.count) || 0
        if (item.name === '主题') {
          count = themeid ? 1 : 0
        }
        if (item.name === '艺术家') {
          count = artistid ? 1 : 0
        }
        // 如果子分类下能找到themeid, 在分类上标注“1”，代表一个选中
        if (l_1 === '风格模型') {
          const has = (item.child || []).find((i: any) => i.idStr === themeid)
          if (has) {
            count = 1
          }
        }

        const showTips = showCount && count !== 0
        const active = index === activeIndex

        return (
          <div
            key={item.id}
            className={classNames(
              'mr-4 cursor-pointer relative pb-1.5 transition-all hover:text-neutral-800',
              {
                'text-neutral-800': active,
              }
            )}
            onClick={() => {
              onChange(index)
            }}
          >
            {item.name}
            {item?.isNew && (
              <img
                className="h-[14px] absolute -top-3 -right-2.5"
                src="/images/ai/new.png"
                alt=""
              />
            )}
            {showTips && (
              <div
                className="absolute -top-2 -right-2.5 py-0.5 px-1.5 rounded-full bg-[#EF466F]
              text-neutral-800 text-[12px] leading-none font-normal border-2 border-solid border-neutral-100"
              >
                {count}
              </div>
            )}
            <div
              className={classNames(
                'absolute bottom-0 left-0 right-0 bg-primary transition-all',
                { 'h-1': active, '!h-0': hiddenUnderline || !active }
              )}
            ></div>
          </div>
        )
      })}
    </div>
  )
}
